import { useEffect, useState } from "react";
import TreeList, { Column } from "devextreme-react/tree-list";

import GoAiguaCheckbox from "components/generic/goaiguacheckbox";

import { getHierarchyFilter } from "utils/functions";

import { GisLayerTableType, HierarchyItemType } from "types/generic";
import { useGisLayersTreeContext } from "storage/context/gis-layers-tree-hierarchy-context";
import { makeGisTreeStructureTableFunctions } from "utils/components/gis-tree-structure-table-functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faLayerGroup } from "@fortawesome/pro-light-svg-icons";

export type CellDataType = {
    data: HierarchyItemType;
    value: any;
};

type Props = {
    textFilter: string;
};

const GisTreeStructureTable: React.FC<Props> = ({ textFilter }) => {
    const [dataSourceFilter, setDataSourceFilter] = useState<
        HierarchyItemType[]
    >([]);

    const {
        gisHierarchyId,
        gisHierarchySelected,
        dataHierarchy,
        setDataHierarchy,
        setGisHierarchySelected,
    } = useGisLayersTreeContext();

    const { handleCheckboxCheck } = makeGisTreeStructureTableFunctions({
        dataHierarchy,
        gisHierarchySelected,
        setGisHierarchySelected,
    });

    useEffect(() => {
        let hierarchyAux = [...gisHierarchyId];

        gisHierarchyId.forEach((param) => {
            param.expanded = true;
            if (param.gisLayers && param.gisLayers.length !== 0) {
                param.gisLayers.forEach((item: GisLayerTableType) => {
                    if (
                        param.id &&
                        item.layerId
                            .toLowerCase()
                            .includes(textFilter.toLowerCase())
                    ) {
                        let newObject: HierarchyItemType = {
                            name: item.layerId,
                            hierarchy: param.hierarchy,
                            itemType: "layer",
                            gisLayers: [],
                            id: -item.id,
                            object: item,
                            parent: param.id,
                            expanded: true,
                        };
                        hierarchyAux.push(newObject);
                    }
                });
            }
        });

        setDataHierarchy(hierarchyAux);

        let dataSourceFilterAux = hierarchyAux.filter((params) => {
            if (params.name.toLowerCase().includes(textFilter.toLowerCase())) {
                return params;
            }
        });

        dataSourceFilterAux.forEach((node) => {
            getHierarchyFilter(hierarchyAux, dataSourceFilterAux, node);
        });

        setDataSourceFilter(dataSourceFilterAux);
    }, [gisHierarchyId, textFilter]);

    return (
        <div className="c-tree-hierarchy__table">
            <TreeList
                dataSource={dataSourceFilter}
                keyExpr="id"
                parentIdExpr="parent"
                id="id"
                showColumnHeaders={false}
                noDataText=""
                expandedRowKeys={dataSourceFilter
                    .filter((data) => data.expanded === true)
                    .map((data) => data.id)}
                onExpandedRowKeysChange={(data) => {
                    setDataSourceFilter((currentList) => {
                        let updatedList = currentList.map((element) => {
                            if (data.includes(element.id)) {
                                element = { ...element, expanded: true };
                                return element;
                            } else {
                                element = { ...element, expanded: false };
                                return element;
                            }
                        });
                        return updatedList;
                    });
                }}
            >
                <Column
                    dataField="name"
                    caption="Groups and layers tree"
                    cellRender={(cellData: CellDataType) => {
                        return (
                            <div
                                className={
                                    "c-tree-hierarchy__check-box-container"
                                }
                            >
                                <div
                                    className={
                                        "c-tree-hierarchy__check-box-element"
                                    }
                                >
                                    <GoAiguaCheckbox
                                        checkedStatus={
                                            gisHierarchySelected.find(
                                                (e: any) =>
                                                    e.id === cellData.data.id
                                            )
                                                ? "checked"
                                                : "not-checked"
                                        }
                                        setCheckedStatus={() =>
                                            handleCheckboxCheck(cellData)
                                        }
                                    />
                                </div>
                                {cellData.data.itemType === "layer" ? (
                                    <FontAwesomeIcon
                                        className="c-tree-hierarchy__icon"
                                        icon={faLayerGroup}
                                    />
                                ) : (
                                    <FontAwesomeIcon
                                        className="c-tree-hierarchy__icon"
                                        icon={faFolder}
                                    />
                                )}

                                <span title={cellData.value}>
                                    {cellData.data.object
                                        ? cellData.data.object.alias
                                        : cellData.value}
                                </span>
                            </div>
                        );
                    }}
                />
            </TreeList>
        </div>
    );
};

export default GisTreeStructureTable;
